import { findHeaderColumns, readCell } from 'features/RateCodes/workbookCells'

const CODE_HEADER = 'rate code'
const CATEGORY_HEADER = 'category'
const HEADER_ROW = 1
const PREFERRED_SHEET_NAME = 'Rates'

/**
 * Our own export workbook: headers on row 1, one row per rate code. The sheet is recognized by
 * its headers rather than by its name, so a workbook a CSM renamed or re-saved still imports.
 */
export function detectNativeSheet(workbook) {
  if (!workbook || !workbook.worksheets) {
    return null
  }

  const preferredSheet = workbook.getWorksheet(PREFERRED_SHEET_NAME)
  const sheets = preferredSheet
    ? [preferredSheet, ...workbook.worksheets.filter(sheet => sheet !== preferredSheet)]
    : workbook.worksheets

  for (const sheet of sheets) {
    const columnsByHeader = findHeaderColumns(sheet.getRow(HEADER_ROW))
    const codeCol = columnsByHeader[CODE_HEADER]
    const categoryCol = columnsByHeader[CATEGORY_HEADER]

    if (codeCol && categoryCol) {
      return { sheet, headerRow: HEADER_ROW, codeCol, categoryCol }
    }
  }

  return null
}

/**
 * Reads a detected native sheet. Rows with an empty code or an unrecognized category label are
 * returned as they are, so the caller can report them rather than losing them silently.
 */
export function readNativeRows(detection) {
  const { sheet, headerRow, codeCol, categoryCol } = detection
  const rows = []

  sheet.eachRow((row, rowNumber) => {
    if (rowNumber <= headerRow) {
      return
    }

    rows.push({
      code: readCell(row, codeCol),
      categoryLabel: readCell(row, categoryCol),
      rowNumber
    })
  })

  return rows
}
